import mitt from 'mitt'

/**
 * Generates an event bus instance using the `mitt` library.
 * @warning
 * This event bus and the use of `mitt` are intended solely for Vue 3 migration purposes.
 * Do not use this event bus for new features.
 * Consider using Provide/Inject, emits or store instead.
 */
export const eventBusGenerator = () => mitt()
